import moment from "moment"
import { extendMoment } from "moment-range"
import {
  CREATE_MEASURE,
  EDIT_MAIL_MEASURE,
  EDIT_TEST_MEASURE,
  SEND_TEST_MEASURE,
  STEP_FINAL_MEASURE,
  STEP_FIRST_MEASURE,
  STEP_SECOND_MEASURE,
  STEP_THIRD_MEASURE,
} from "../events"
import { identifyUserSegment } from "../segmentTracks"
import { getModelSurvey } from "../Survey/surveyTrack"
import {
  changeAttributesMeasure,
  changeAttributesScheduleMeasure,
  changeAttributesDaysResend,
} from "../attributesSegment"
import { LOCAL_USER_EMAIL } from "../../storage"

const momentRange = extendMoment(moment)

export const getDaysFrequencyRange = (date_resend, date_start, date_end) => {
  const range = momentRange.range(moment(date_start), moment(date_end))
  let count = 0
  for (const day of range.by("days")) {
    date_resend.filter((date) => (date === day.format("dd") ? count++ : null))
  }
  return count || -1
}

/**
 *
 * @param nameMeasure
 */
export const setupMailMeasureSegment = (nameMeasure) => {
  window.analytics.track(STEP_FIRST_MEASURE, {
    data: identifyUserSegment(),
    email: LOCAL_USER_EMAIL(),
    nombre_medicion: nameMeasure,
  })
}

/**
 *
 * @param nameMeasure
 * @param campo_editado
 */
export const createMeasureSegment = (nameMeasure, survey) => {
  window.analytics.track(CREATE_MEASURE, {
    data: identifyUserSegment(),
    email: LOCAL_USER_EMAIL(),
    nombre_medicion: nameMeasure,
    nombre_cuestionario: survey.name,
    tipo_cuestionario: survey.survey_type,
    modelo_cuestionario: getModelSurvey(survey),
  })
}

/**
 *
 * @param nameMeasure
 * @param campo_editado
 */
export const editMailMeasureSegment = (nameMeasure, campo_editado) => {
  window.analytics.track(EDIT_MAIL_MEASURE, {
    data: identifyUserSegment(),
    email: LOCAL_USER_EMAIL(),
    nombre_medicion: nameMeasure,
    campo_editado: changeAttributesMeasure(campo_editado, "normal"),
    ph_campo_editado: changeAttributesMeasure(campo_editado, "planhat"),
  })
}

/**
 *
 * @param nameMeasure
 */
export const selectCollaboratorMeasureSegment = (
  nameMeasure,
  totalCollaborator
) => {
  window.analytics.track(STEP_SECOND_MEASURE, {
    data: identifyUserSegment(),
    email: LOCAL_USER_EMAIL(),
    nombre_medicion: nameMeasure,
    total_destinatarios: totalCollaborator,
  })
}

/**
 *
 * @param nameMeasure
 * @param isWatch
 */
export const previewMeasureSegment = (nameMeasure, isWatch) => {
  window.analytics.track(STEP_THIRD_MEASURE, {
    data: identifyUserSegment(),
    email: LOCAL_USER_EMAIL(),
    nombre_medicion: nameMeasure,
    previsualizo: isWatch ? "Si" : "No",
  })
}

/**
 *
 * @param nameMeasure
 */
export const sendMeasureSegment = (nameMeasure) => {
  window.analytics.track(SEND_TEST_MEASURE, {
    data: identifyUserSegment(),
    email: LOCAL_USER_EMAIL(),
    nombre_medicion: nameMeasure,
  })
}

export const programMeasureSegment = (
  nameMeasure,
  dateFrom,
  dateTo,
  timeSend,
  attempts,
  date_resend = ""
) => {
  window.analytics.track(STEP_FINAL_MEASURE, {
    data: identifyUserSegment(),
    email: LOCAL_USER_EMAIL(),
    nombre_medicion: nameMeasure,
    fecha_inicio_fecha_fin: `${dateFrom.format("D/M/Y")} - ${dateTo.format(
      "D/M/Y"
    )}`,
    hora_envio: timeSend.format("HH:mm:ss"),
    reenvios: attempts,
    dias_reenvio: changeAttributesDaysResend(date_resend),
  })
}

export const editScheduleMeasureSegment = (
  nameMeasure,
  campo_editado,
  date_resend = ""
) => {
  window.analytics.track(EDIT_TEST_MEASURE, {
    data: identifyUserSegment(),
    email: LOCAL_USER_EMAIL(),
    nombre_medicion: nameMeasure,
    campo_editado: changeAttributesScheduleMeasure(campo_editado, "normal"),
    ph_campo_editado: changeAttributesScheduleMeasure(campo_editado, "planhat"),
    //  dias_reenvio : date_resend
  })
}
